import { baseUrl } from "../../../config.js";
import { EventBus } from "../../../eventbus";
import VueRecaptcha from "vue-recaptcha";
import i18n from "../../../functions/i18next";

export default {
  data() {
    return {
      user: this.$store.state.user,
      company: this.$store.state.company,
      company_full: this.$store.state.company_full,
      error: "",
      username: "",
      password: "",
      emailforget: "",
      role: "",
      state:
        window.location.pathname.substring(
          window.location.pathname.lastIndexOf("/") + 1
        ) === "reset" ||
        window.location.pathname.substring(
          window.location.pathname.lastIndexOf("/") + 1
        ) === "userforget"
          ? window.location.pathname.substring(
              window.location.pathname.lastIndexOf("/") + 1
            )
          : "login",
      passworderror: "",
      usererror: "",
      linksend: false,
      linksend2: false,
      menutoggle: false,
      menu: this.$store.state.user,
      firstNameAccess: "",
      lastNameAccess: "",
      fullNameAccess: "",
      emailAccess: "",
      telephoneAccess: "",
      companyNameAccess: "",
      countryAccess: "",
      fieldAccess: "",
      addressAccess: "",
      accesRequestError: "",
      accesrequestSend: false,
      accesRequestSubmitted: false,
      captchaIsVerified: false,
      empty: true,
      requestPage: 1,
      statesList: ["reset", "userforget"],
    };
  },
  components: { VueRecaptcha },
  watch: {
    menutoggle: function (val, old) {
      /**
       * When the user is not logged in and the menu is toggled
       * -- set autofocus on the email input field
       */

      this.$emit("changeOpenLoginScreenEvent", this.menutoggle);
      //EventBus.$emit("openLoginScreenViaEventBus",this.menutoggle);

      if (!this.user && val) {
        this.$refs.username.focus();
      }
    },
  },
  created() {
    //set init state based on url
    this.setInitState();

    EventBus.$on("requestAccessButton", (data) => {
      this.menutoggle = true;
      this.state = "requestaccess";
    });

    EventBus.$on("requestAccessButtonReset", (data) => {
      this.menutoggle = true;
      this.state = "login";
    });

    if (!this.user) {
      this.role = null;
    } else {
      this.$axios
        .get(baseUrl + "/role?id=" + (this.user ? this.user.role_id : null))
        .then((response) => {
          this.role = response.data.role;
        });
    }
  },
  methods: {
    setInitState() {
      const route = this.$route.path;

      this.statesList.forEach((state) => {
        if (route.includes(state)) {
          this.menutoggle = true;
          this.state = state;
        }
      });
    },
    captchaVerified(response) {
      this.captchaIsVerified = true;
    },
    submit(event) {
      event.preventDefault();
      if (this.state === "login") {
        let formData = new FormData();
        formData.append("username", this.username);
        formData.append("password", this.password);
        this.$axios
          .post(baseUrl + "/login", formData)
          .then((response) => {
            if (response.data) {
              this.menutoggle = false;
              this.user = response.data;
              this.menu = response.data;
              this.$store.state.user = response.data;
              this.$axios.defaults.params["key"] = response.data.key;
              localStorage.setItem(
                this.$store.state.company + "_" + "user",
                JSON.stringify(response.data)
              );
              this.$axios
                .get(
                  baseUrl + "/role?id=" + (this.user ? this.user.role_id : null)
                )
                .then((response) => {
                  this.$store.state.role = response.data.role;
                });

              EventBus.$emit("login");
              EventBus.$emit(`home-right-content-close`);

              var urlParams = new URLSearchParams(window.location.search);
              if (urlParams.has("r")) {
                window.location = urlParams.get("r");
                window.location.reload();
              }
            } else {
              this.error = i18n.t("login.credentials_match_error");
              this.menutoggle = true;
            }
          })
          .catch((thrown) => {
            if (this.axios.isCancel(thrown)) {
              this.error = i18n.t("common.something_went_wrong");
            } else {
              this.error = i18n.t("common.something_went_wrong");
            }
          });
      }
    },
    passwordReset(event) {
      event.preventDefault();
      let formData = new FormData();
      formData.append("username", this.username);
      this.$axios
        .post(baseUrl + "/passwordreset", formData)
        .then((response) => {
          if (response.data) {
            this.passworderror = "";
            this.linksend = true;
          } else {
            this.passworderror = i18n.t("upload.user_unknown");
          }
        })
        .catch((thrown) => {
          if (this.axios.isCancel(thrown)) {
            this.passworderror = i18n.t("common.something_went_wrong");
          } else {
            this.passworderror = i18n.t("common.something_went_wrong");
          }
        });
    },
    userForget(event) {
      event.preventDefault();
      let formData = new FormData();
      formData.append("email", this.emailforget);
      this.$axios
        .post(baseUrl + "/usernameforget", formData)
        .then((response) => {
          if (response.data) {
            this.usererror = "";
            this.linksend2 = true;
          } else {
            this.usererror = i18n.t("upload.email_unknown");
          }
        })
        .catch((thrown) => {
          if (this.axios.isCancel(thrown)) {
            this.usererror = i18n.t("common.something_went_wrong");
          } else {
            this.usererror = i18n.t("common.something_went_wrong");
          }
        });
    },
    requestAccess(event) {
      event.preventDefault();

      event.target.disabled = true;

      if (!this.accesRequestSubmitted) {
        if (this.firstNameAccess == "") {
          this.accesRequestError = `${i18n.t("common.first_name")} ${i18n.t(
            "login.is_required"
          )}`;
          return;
        }
        if (this.lastNameAccess == "") {
          this.accesRequestError = `${i18n.t("common.last_name")} ${i18n.t(
            "login.is_required"
          )}`;
          return;
        }
        if (this.countryAccess == "") {
          this.accesRequestError = `${i18n.t("common.country")} ${i18n.t(
            "login.is_required"
          )}`;
          return;
        }
        if (this.telephoneAccess == "") {
          this.accesRequestError = `${i18n.t("common.telephone")} ${i18n.t(
            "login.is_required"
          )}`;
          return;
        }
        if (this.companyNameAccess == "") {
          this.accesRequestError = `${i18n.t("account.company_name")} ${i18n.t(
            "login.is_required"
          )}`;
          return;
        }
        if (this.addressAccess == "") {
          this.accesRequestError = `${i18n.t("common.address")} ${i18n.t(
            "login.is_required"
          )}`;
          return;
        }
        if (this.fieldAccess == "") {
          this.accesRequestError = `${i18n.t(
            "login.field_of_activity"
          )} ${i18n.t("login.is_required")}`;
          return;
        }
        let re =
          /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if (!re.test(this.emailAccess)) {
          this.accesRequestError = i18n.tc("common.email_error", 1);
          return;
        }
        if (!this.captchaIsVerified) {
          this.accesRequestError = `Captcha ${i18n.t("login.is_required")}`;
          return;
        }
        this.accesRequestError = "";
        this.accesRequestSubmitted = true;
        let formData = new FormData();
        formData.append(
          "fullname",
          this.firstNameAccess.trim() + " " + this.lastNameAccess.trim()
        );
        formData.append("email", this.emailAccess);
        formData.append("tel", this.telephoneAccess);
        formData.append("address", this.addressAccess);
        formData.append("country", this.countryAccess);
        formData.append("field", this.fieldAccess);
        formData.append("companyAccessing", this.companyNameAccess);
        this.$axios
          .post(baseUrl + "/requestaccess", formData)
          .then((response) => {
            if (response.data) {
              if (response.data.error) {
                this.accesRequestError = response.data.error;
              } else {
                this.accesRequestError = "";
                // this.accesrequestSend = true;
                this.state = "requestaccess-success";
              }
              this.accesRequestSubmitted = false;
            } else {
              this.accesRequestError = i18n.t("common.something_went_wrong");
            }

            event.target.disabled = false;
          })
          .catch((thrown) => {
            this.accesRequestError = i18n.t("common.something_went_wrong");
            event.target.disabled = false;
          });
      }
    },
    goTo(route) {
      this.$router.push(route);
    },
    showPassword(event) {
      /**
       * When the button is clicked, stay on the same page
       */
      event.preventDefault();

      /**
       * currentParent = the parent of the clicked button
       * passwordField = the password field
       * passwordType = the type of the password field
       *
       * @type {HTMLElement}
       */
      let currentParent = event.currentTarget.parentElement;
      let passwordField = currentParent.querySelector("#password");
      let passwordType = passwordField.getAttribute("type");

      /**
       * When the button is clicked toggle the type of the password field between text and password
       * -- When the type is password, the password will not be readable and ••• will be shown
       * -- When the type is test, the password will be readable
       */
      if (passwordType == "password") {
        currentParent.classList.add("is-visible");
        passwordField.setAttribute("type", "text");
      } else {
        currentParent.classList.remove("is-visible");
        passwordField.setAttribute("type", "password");
      }
    },
    back() {
      if (this.empty) {
        this.menutoggle = false;
      }
      this.state = "login";
    },
  },
};
